<script setup lang="ts">
import MedicationCheckupCopiloteLine from "@/medication-checkup/components/MedicationCheckupCopiloteLine.vue";
import MedicationCheckupUserEcho from "@/medication-checkup/components/MedicationCheckupUserEcho.vue";
import MedicationCheckupCopiloteBubble from "@/medication-checkup/components/MedicationCheckupCopiloteBubble.vue";
import MedicationCheckupSceneReplies from "@/medication-checkup/components/MedicationCheckupSceneReplies.vue";
import {IntroductionView} from "@/medication-checkup/interfaces/introduction";
import {SceneProps} from "@/medication-checkup/composables/useScene";
import {useDoorstepScene} from "@/medication-checkup/composables/useDoorstepScene";

/**
 * The scene of the doorstep of the analysis: the first scene of the second
 * step, held without the patient, another day than the collection.
 *
 * Its bubble recalls where the collection left the course — the patient, the
 * day the interview ended, the treatments retained — and the one action
 * starts analysing. All of it is served by the handler of the block; the
 * scene owns the rendering only, and plays the same mechanic as the
 * introduction of the collection.
 */

const props = defineProps<SceneProps<IntroductionView>>();

const {bubbleShown, repliesShown, clicked, text, actions, acted, act} = useDoorstepScene(props);
</script>

<template>
  <div class="flex flex-col gap-3.5">
    <template v-if="frozen">
      <MedicationCheckupCopiloteLine v-if="text" :text="text" />
      <MedicationCheckupUserEcho v-if="acted" :text="acted" />
    </template>

    <template v-else>
      <MedicationCheckupCopiloteBubble
        :shown="bubbleShown"
        :text="text"
      />

      <MedicationCheckupSceneReplies
        :clicked="clicked"
        :actions="actions"
        :shown="repliesShown"
        @act="act"
      />
    </template>
  </div>
</template>
